/** One cell of the 4-up stat strip (mock `.sh-stats`/`.hod-stats`). `alert` paints the number red. */
export interface DetailStat {
  label: string
  value: string | number
  alert?: boolean
}

/** 4-up stat strip shared by Site hero and HOD hero. */
export function DetailStatStrip({ stats }: { stats: DetailStat[] }) {
  return (
    <div className="grid grid-cols-4 gap-px overflow-hidden rounded-[14px] border border-gis-line-2 bg-gis-line-2">
      {stats.map((s) => (
        <div key={s.label} className="bg-white px-2 py-3 text-center">
          <div className={`text-[19px] leading-none font-bold tracking-[-.02em] tabular-nums ${s.alert ? 'text-gis-red' : 'text-gis-ink'}`}>
            {s.value}
          </div>
          <div className="mt-1.5 text-[10px] font-semibold tracking-[.03em] text-gis-subheading uppercase">{s.label}</div>
        </div>
      ))}
    </div>
  )
}
